import { render, staticRenderFns } from "./ExceptionSidebar.vue?vue&type=template&id=2d4227f8&scoped=true"
import script from "./ExceptionSidebar.vue?vue&type=script&lang=js"
export * from "./ExceptionSidebar.vue?vue&type=script&lang=js"
import style0 from "./ExceptionSidebar.vue?vue&type=style&index=0&id=2d4227f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4227f8",
  null
  
)

export default component.exports